import Index from './index.jsx';

function App() {
    return <Index />
}

export default App
